import LoanInstallmentTable from './loan-installment-table';

export default LoanInstallmentTable;
